import React from "react";
import { Icon } from "semantic-ui-react";
import { Translate } from "material-ui-icons";
import { Spellcheck } from "material-ui-icons";
import Tooltip from "src/components/Tooltip";
import MagicWandIcon from "./MagicWandIcon";

interface TranslateIconButtonProps {
    loading: boolean;
    value: string;
    onClick?: () => void;
    disabled?: boolean;
    type?: 'translate' | 'grammar' | 'suggestion';
    tooltipMessage?: string;
}

const TranslateIconButton: React.FC<TranslateIconButtonProps> = ({
    loading,
    value,
    onClick,
    disabled = false,
    type = 'translate',
    tooltipMessage
}) => {
    const isClickable = !loading && value && !disabled;
    const defaultMessage = type === 'translate' ? "AI Translate" : "AI Grammar Check";

    return (
        <Tooltip
            tooltipMessage={tooltipMessage || defaultMessage}
            className={type === 'grammar' ? 'grammar-tooltip' : 'translate-tooltip'}
            offsetX={60}
        >
        <div
            className={`${type}-icon`}
            onClick={isClickable ? onClick : undefined}
            role="button"
            aria-label={type === 'translate' ? "Preview translation" : "Check grammar"}
            style={{
                minWidth: 32,
                minHeight: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: value && !disabled ? 1 : 0.5,
                cursor: isClickable ? "pointer" : "not-allowed",
                marginLeft: type === 'grammar' ? '8px' : '0px'
            }}
        >
            {loading ? (
                <Icon name="spinner" size="large" color="blue" loading={true} />
            ) : (
                // Toggle icon based on type
                <>
                    {type === 'translate' && <Translate />}
                    {type === 'grammar' && <Spellcheck />}
                    {type === 'suggestion' &&<MagicWandIcon style={{ color: 'blue' }} />}
                </>
            )}
        </div>
        </Tooltip>
    );
};

export default TranslateIconButton;



// WEBPACK FOOTER //
// ./src/components/Table/components/twoLanguage/TranslateIconButton.tsx